import React from 'react';
import {
  DarkSearchInput,
  DatesPickerDropDown,
  ResetFilter,
} from '../../../../component';

const HistoryFilter = (props) => {
  const {
    intl,
    language,
    handleSearch,
    handleChangedropDown,
    handleOrderDateFilter,
    handleTravelDateFilter,
    handleResetFilter,
    historyFilterData: {
      phrase,
      isShowOrderDropDown,
      isShowTravelDropDown,
      orderStartDateValue,
      orderEndDateValue,
      travelStartDateValue,
      travelEndDateValue,
      orderResetDates,
      travelResetDates,
    },
  } = props;
  return (
    <>
      <div className="w-100 d-flex p-0  font-xsmall text-third justify-content-between align-items-center mb-4 height-tab">
        <DarkSearchInput
          name="historyPhrase"
          value={phrase}
          className={'col h-100 p-0 d-flex flex-row justify-content-center'}
          intl={intl}
          onChange={({ target }) => handleSearch('historyPhrase', target.value)}
          language={language}
        />
        <div className="col h-100 p-0 d-flex flex-row justify-content-center">
          <DatesPickerDropDown
            name="orderDateDropdown"
            className="w-100 d-flex flex-row justify-content-center text-dark"
            label="booking.orderdate"
            boxColor="bg-white border"
            show={isShowOrderDropDown}
            direction={language?.direction}
            onClickTab={() => handleChangedropDown('orderDropDown')}
            placement="center"
            startDateData={orderStartDateValue}
            endDateData={orderEndDateValue}
            resetDate={orderResetDates}
            onChange={(event) => {
              handleOrderDateFilter(event);
            }}
          />
        </div>
        <div className="col h-100 p-0 d-flex flex-row justify-content-center">
          <DatesPickerDropDown
            name="travelDateDropdown"
            className="w-100 d-flex flex-row justify-content-center text-dark"
            label="booking.traveldate"
            boxColor="bg-white border"
            startDateLocalization="profile.startTravelDate"
            endDateLocalization="profile.endTravelDate"
            show={isShowTravelDropDown}
            direction={language?.direction}
            onClickTab={() => handleChangedropDown('travelDropDown')}
            resetDate={travelResetDates}
            startDateData={travelStartDateValue}
            endDateData={travelEndDateValue}
            onChange={(event) => {
              handleTravelDateFilter(event);
            }}
          />
        </div>
        <ResetFilter placement="large-space" handleReset={handleResetFilter} />
      </div>
    </>
  );
};
export default HistoryFilter;
